import React, {
    FC,
    ReactNode,
    useEffect,
    useLayoutEffect,
    useRef,
    useState,
} from 'react';
import logo from '../../static/logo.svg';
import main from '../../static/main.svg';
import points from '../../static/points.svg';
import materials from '../../static/materials.svg';
import timetable from '../../static/timetable.svg';
import homework from '../../static/homework.svg';
import SidebarItem from './SidebarItem';
import { Sidebar as PrimeSidebar } from 'primereact/sidebar';
import './StudentSidebar.scss';
import { IProps } from './StudentSidebar.types';
import { Link, useLocation } from 'react-router-dom';
import { Button } from 'primereact/button';
import { actions, logout } from 'src/store/user/user.slice';
import useAppDispatch from '../../hooks/useAppDispatch';
import { map } from 'lodash';
import useAppSelector from '../../hooks/useAppSelector';
import { sidebarWidthSlice } from 'src/store/sidebarWidth/sidebarWidth.slice';
import { IUser } from 'src/store/user/user.types';
import { useLazyGetCountUnShowedPracticeQuery } from 'src/api/endpoints/practice';
import { BranchSelector } from 'src/components/BranchSelector';
import { CurrentUser } from 'src/api/endpoints/auth/api';
import { Branch } from 'src/api/endpoints/branches/api';

interface Menu {
    pathname: string;
    background: string;
    children: ReactNode;
    indicator?: keyof IUser;
}

type Menus = (branchId: string | number) => Array<Menu>;

const studentMenu: Menus = () => [
    {
        pathname: '/',
        background: '#3B82F610',
        children: <SidebarItem title="Главная" img={main} link={'/'} />,
    },
    {
        pathname: '/progress',
        background: '#44AFAF10',
        children: (
            <SidebarItem title="Успеваемость" img={points} link={'/progress'} />
        ),
    },
    {
        pathname: '/homeworks',
        background: '#D9770610',
        children: (
            <SidebarItem
                title="Домашнее задание"
                img={homework}
                link={'/homeworks'}
            />
        ),
    },
    {
        pathname: '/materials',
        background: '#8D44AF10',
        children: (
            <SidebarItem
                title="Учебные материалы"
                img={materials}
                link={'/materials'}
            />
        ),
    },
    {
        pathname: '/schedule',
        background: '#3B82F610',
        children: (
            <SidebarItem
                title="Расписание"
                img={timetable}
                link={'/schedule'}
            />
        ),
    },
];

const teacherMenu: Menus = (branchId: string | number) => [
    {
        pathname: `/b/${branchId}/schedule`,
        background: '#3B82F610',
        children: (
            <SidebarItem
                title="Расписание"
                img={timetable}
                link={`/b/${branchId}/schedule`}
            />
        ),
    },
    {
        pathname: `/b/${branchId}/attendance`,
        background: '#44AFAF10',
        children: (
            <SidebarItem
                title="Присутствующие"
                img={points}
                link={`/b/${branchId}/attendance`}
            />
        ),
    },
    {
        pathname: '/materials',
        background: '#8D44AF10',
        children: (
            <SidebarItem
                title="Методические материалы"
                img={materials}
                link={'/materials'}
            />
        ),
    },
    {
        pathname: `/b/${branchId}/homeworks`,
        background: 'rgba(217,119,6,0.06)',
        children: (
            <SidebarItem
                title="Домашнее задание"
                img={homework}
                link={`/b/${branchId}/homeworks`}
            />
        ),
    },
];

const eduMenu: Menus = (branchId: string | number) => [
    {
        pathname: `/b/${branchId}/attendance`,
        background: '#44AFAF10',
        children: (
            <SidebarItem
                title="Посещаемость"
                img={points}
                link={`/b/${branchId}/attendance`}
            />
        ),
    },
    {
        pathname: `/b/${branchId}/schedule`,
        background: '#3B82F610',
        children: (
            <SidebarItem
                title="Расписание"
                img={timetable}
                link={`/b/${branchId}/schedule`}
            />
        ),
    },
    {
        pathname: `/materials`,
        background: '#8D44AF10',
        children: (
            <SidebarItem
                title="Учебные материалы"
                img={materials}
                link={'/materials'}
            />
        ),
    },
    {
        pathname: `/b/${branchId}/audiences`,
        background: '#8D44AF10',
        children: (
            <SidebarItem
                title="Аудитории"
                img={materials}
                link={`/b/${branchId}/audiences`}
            />
        ),
    },
    {
        pathname: `/subjects`,
        background: '#8D44AF10',
        children: (
            <SidebarItem title="Предметы" img={materials} link={'/subjects'} />
        ),
    },
    {
        pathname: `/b/${branchId}/groups`,
        background: '#8D44AF10',
        children: (
            <SidebarItem
                title="Группы"
                img={materials}
                link={`/b/${branchId}/groups`}
            />
        ),
    },
    {
        pathname: `/b/${branchId}/students/academic-leaves/`,
        background: '#8D44AF10',
        children: (
            <SidebarItem
                title="Академические отпуска"
                img={materials}
                link={`/b/${branchId}/students/academic-leaves/`}
            />
        ),
    },
    {
        pathname: `/b/${branchId}/students`,
        background: '#8D44AF10',
        children: (
            <SidebarItem
                title="Студенты"
                img={materials}
                link={`/b/${branchId}/students`}
            />
        ),
    },
    {
        pathname: `/b/${branchId}/debts`,
        background: '#8D44AF10',
        children: (
            <SidebarItem
                title="Задолженности"
                img={materials}
                link={`/b/${branchId}/debts`}
            />
        ),
    },
];

const directorFilialMenu: Menus = (branchId: string | number) => [
    {
        pathname: `/b/${branchId}/attendance`,
        background: '#44AFAF10',
        children: (
            <SidebarItem
                title="Посещаемость"
                img={points}
                link={`/b/${branchId}/attendance`}
            />
        ),
    },
    {
        pathname: `/b/${branchId}/schedule`,
        background: '#3B82F610',
        children: (
            <SidebarItem
                title="Расписание"
                img={timetable}
                link={`/b/${branchId}/schedule`}
            />
        ),
    },
    {
        pathname: `/materials`,
        background: '#8D44AF10',
        children: (
            <SidebarItem
                title="Учебные материалы"
                img={materials}
                link={'/materials'}
            />
        ),
    },
    {
        pathname: `/b/${branchId}/audiences`,
        background: '#8D44AF10',
        children: (
            <SidebarItem
                title="Аудитории"
                img={materials}
                link={`/b/${branchId}/audiences`}
            />
        ),
    },
    {
        pathname: `/subjects`,
        background: '#8D44AF10',
        children: (
            <SidebarItem title="Предметы" img={materials} link={'/subjects'} />
        ),
    },
    {
        pathname: `/b/${branchId}/groups`,
        background: '#8D44AF10',
        children: (
            <SidebarItem
                title="Группы"
                img={materials}
                link={`/b/${branchId}/groups`}
            />
        ),
    },
    {
        pathname: `/b/${branchId}/students/academic-leaves/`,
        background: '#8D44AF10',
        children: (
            <SidebarItem
                title="Академические отпуска"
                img={materials}
                link={`/b/${branchId}/students/academic-leaves/`}
            />
        ),
    },
    {
        pathname: `/b/${branchId}/students`,
        background: '#8D44AF10',
        children: (
            <SidebarItem
                title="Студенты"
                img={materials}
                link={`/b/${branchId}/students`}
            />
        ),
    },

    {
        pathname: `/b/${branchId}/employees`,
        background: '#8D44AF10',
        children: (
            <SidebarItem
                title="Сотрудники"
                img={materials}
                link={`/b/${branchId}/employees`}
            />
        ),
    },
    {
        pathname: `/b/${branchId}/debts`,
        background: '#8D44AF10',
        children: (
            <SidebarItem
                title="Задолженности"
                img={materials}
                link={`/b/${branchId}/debts`}
            />
        ),
    },
];

const directorCompanyMenu: Menus = (branchId: string | number) => [
    {
        pathname: '/employees',
        background: '#8D44AF10',
        children: (
            <SidebarItem
                title="Сотрудники"
                img={materials}
                link={'/employees'}
            />
        ),
    },
    {
        pathname: `/b/${branchId}/attendance`,
        background: '#44AFAF10',
        children: (
            <SidebarItem
                title="Посещаемость"
                img={points}
                link={`/b/${branchId}/attendance`}
            />
        ),
    },
    {
        pathname: `/b/${branchId}/schedule`,
        background: '#3B82F610',
        children: (
            <SidebarItem
                title="Расписание"
                img={timetable}
                link={`/b/${branchId}/schedule`}
            />
        ),
    },
    {
        pathname: `/materials`,
        background: '#8D44AF10',
        children: (
            <SidebarItem
                title="Учебные материалы"
                img={materials}
                link={'/materials'}
            />
        ),
    },
    {
        pathname: `/b/${branchId}/audiences`,
        background: '#8D44AF10',
        children: (
            <SidebarItem
                title="Аудитории"
                img={materials}
                link={`/b/${branchId}/audiences`}
            />
        ),
    },
    {
        pathname: `/subjects`,
        background: '#8D44AF10',
        children: (
            <SidebarItem title="Предметы" img={materials} link={'/subjects'} />
        ),
    },
    {
        pathname: `/b/${branchId}/groups`,
        background: '#8D44AF10',
        children: (
            <SidebarItem
                title="Группы"
                img={materials}
                link={`/b/${branchId}/groups`}
            />
        ),
    },
    {
        pathname: `/b/${branchId}/students/academic-leaves/`,
        background: '#8D44AF10',
        children: (
            <SidebarItem
                title="Академические отпуска"
                img={materials}
                link={`/b/${branchId}/students/academic-leaves/`}
            />
        ),
    },
    {
        pathname: `/b/${branchId}/students`,
        background: '#8D44AF10',
        children: (
            <SidebarItem
                title="Студенты"
                img={materials}
                link={`/b/${branchId}/students`}
            />
        ),
    },
];

const menus: (branchId: string | number) => Record<number, any> = (
    branchId: string | number
) => ({
    1: studentMenu(branchId),
    2: teacherMenu(branchId),
    3: eduMenu(branchId),
    4: directorFilialMenu(branchId),
    5: directorCompanyMenu(branchId),
});

export const getSelectedBranchScope = (
    whoami: CurrentUser,
    availableBranches: Branch[] = []
): number => {
    const selectedId: string | null = localStorage.getItem('selected-branch');

    if (!selectedId) return whoami.defaultBranchId;

    const selectedBranch: Branch | null =
        availableBranches.find(
            (branch: Branch): boolean => branch.id.toString() === selectedId
        ) ?? null;

    if (!selectedBranch) return whoami.defaultBranchId;

    return selectedBranch.id;
};

export const Sidebar: FC<IProps> = ({
    isVisible,
    onHide,
    mobileData,
    auth,
}) => {
    const { user, branches } = auth;

    const sidebarWidth = useAppSelector(
        state => state.sidebarWidthReducer.width
    );
    const { setSidebarWidth } = sidebarWidthSlice.actions;
    const [isMobile, setIsMobile] = useState(false);
    const dispatch = useAppDispatch();

    const { pathname } = useLocation();
    const sidebarRef = useRef<HTMLDivElement>(null);
    const [triggerPractices, practiceResult] =
        useLazyGetCountUnShowedPracticeQuery();

    useEffect(() => {
        if (!user) return;

        if (user.role.id === 1 && practiceResult.isUninitialized)
            triggerPractices()
                .unwrap()
                .then(e => {
                    dispatch(actions.setPractices(e || 0));
                });
    }, []);

    useLayoutEffect(() => {
        function updateSize() {
            setTimeout(() => {
                const clientWidth = sidebarRef.current?.clientWidth;

                if (clientWidth !== sidebarWidth) {
                    dispatch(setSidebarWidth(clientWidth || sidebarWidth));
                }
            }, 1);
        }

        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    const sidebar = (
        <div className="sidebar h-full" ref={sidebarRef}>
            <div
                className="sidebar-content flex flex-column align-items-center"
                style={{
                    width: sidebarWidth,
                }}
            >
                <div className="logo-container w-full flex flex-column align-items-center">
                    <Link to="/" className="logo">
                        <img src={logo} alt="logo" />
                    </Link>

                    <div
                        className="branch-selector-wrapper"
                        style={{ width: '100%', padding: '0 10px' }}
                    >
                        <BranchSelector/>
                    </div>

                    <ul className="nav w-full">
                        {map(
                            user
                                ? menus(
                                      getSelectedBranchScope(
                                          user,
                                          branches ?? []
                                      )
                                  )[user.role.id]
                                : [],
                            ({
                                pathname: itemPathname,
                                children,
                                background,
                                indicator,
                            }) => (
                                <li
                                    key={itemPathname}
                                    style={{
                                        position: 'relative',
                                        background:
                                            pathname === itemPathname
                                                ? background
                                                : undefined,
                                    }}
                                >
                                    {children}
                                    {indicator && user[indicator] ? (
                                        <span className={'sidebar__indicator'}>
                                            {user[indicator]}
                                        </span>
                                    ) : null}
                                </li>
                            )
                        )}
                        <li>
                            <div
                                className="nav-link flex align-items-center last cursor-pointer"
                                onClick={() => dispatch(logout())}
                            >
                                <div className="icon">
                                    <Button
                                        icon="pi pi-times"
                                        className="p-button-rounded p-button-danger p-button-outlined"
                                    />
                                </div>
                                <div className="text">Выйти</div>
                            </div>
                        </li>
                    </ul>
                    {isMobile && user && user.role.id === 1 ? (
                        <div className="mobile-data mt-auto w-full flex align-items-center justify-content-between mt-12">
                            <div className="ml-24">{mobileData.curGroup}</div>
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );

    useLayoutEffect(() => {
        function updateSize() {
            if (window.innerWidth < 1350) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        }

        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    if (isMobile) {
        return (
            <PrimeSidebar
                blockScroll={true}
                visible={isVisible}
                onHide={onHide}
                position="right"
            >
                {sidebar}
            </PrimeSidebar>
        );
    }

    return sidebar;
};
